import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const OrderPlacedIcon = ({ color, checkMarkColor, className }: IconProps & { checkMarkColor?: string }) => {
  return (
    <svg
      className={className}
      width="46"
      height="42"
      viewBox="0 0 46 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.6353 12.0391H4.14746C2.48683 12.0391 1.14062 13.3853 1.14062 15.0459V37.9929C1.14062 39.6535 2.48683 40.9997 4.14746 40.9997H30.6353C32.296 40.9997 33.6422 39.6535 33.6422 37.9929V15.0459C33.6422 13.3853 32.296 12.0391 30.6353 12.0391Z"
        stroke={color ?? 'current-color'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.15039 12.0391C9.15039 7.48925 12.8496 3.79004 17.3994 3.79004C21.9492 3.79004 25.6484 7.48925 25.6484 12.0391"
        stroke={color ?? 'current-color'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6484 16.9053C25.6484 21.4551 21.9492 25.1543 17.3994 25.1543C12.8496 25.1543 9.15039 21.4551 9.15039 16.9053"
        stroke={color ?? 'current-color'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8609 12.1628C44.8609 5.99769 39.8631 0.999892 33.698 0.999893C27.533 0.999893 22.5352 5.99769 22.5352 12.1628C22.5352 18.3279 27.533 23.3257 33.698 23.3257C39.8631 23.3257 44.8609 18.3279 44.8609 12.1628Z"
        fill={color ?? 'currentColor'}
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.582 7.97656L32.4636 15.6511L28.8145 12.4276"
        stroke={checkMarkColor ?? '#ECECEC'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OrderPlacedIcon;
